import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical domain guard: if the site is being served from any Emergent
// preview/host alias (e.g. bro-site-creator.emergentagent.host) instead of the
// primary domain, redirect the visitor to skywaygreen.com so customers never
// see the internal preview URL. The `.preview.emergentagent.com` dev URL is
// intentionally left untouched so the builder can still test.
if (typeof window !== "undefined") {
  const host = window.location.hostname;
  const isEmergentHost = host.endsWith(".emergentagent.host");
  if (isEmergentHost) {
    const target = "https://skywaygreen.com" + window.location.pathname + window.location.search + window.location.hash;
    window.location.replace(target);
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
